<script>

import { Overlay } from '../../'

export default {
    name: 'SAR',
    mixins: [Overlay],
    methods: {
        meta_info() {
            return {
                author: 'StdSquad', version: '1.0.0',
                desc: 'Parabolic SAR',
                preset: {
                    name: 'SAR $start $inc $max',
                    side: 'onchart',
                    settings: {
                        lineWidth: 2,
                        color: '#35a9c6'
                    }
                }
            }
        },
        use_for() { return ['SAR'] },
        calc() {
            return {
                props: {
                    start: { def: 0.02, text: 'Start', min: 0.001, max: 1, step: 0.001 },
                    inc: { def: 0.02, text: 'Increment', min: 0.001, max: 1, step: 0.001 },
                    max: { def: 0.2, text: 'Maximum', min: 0.001, max: 1, step: 0.001 }
                },
                conf: { renderer: 'PlotCross' },
                update: `
                    return sar(start, inc, max)[0]
                `
            }
        }
    }
}
</script>
